import { ArrowRight, Sparkles } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden pt-40 pb-28 md:pt-56 md:pb-40"
    >
      {/* Violet radial glow */}
      <div className="absolute inset-0 -z-10 violet-glow" aria-hidden />
      {/* Faint technical grid */}
      <div
        className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-70"
        aria-hidden
      />
      {/* Corner brackets */}
      <div
        className="pointer-events-none absolute top-24 left-6 md:left-12 text-violet-400/40 font-mono-ui text-xs tracking-[0.3em]"
        aria-hidden
      >
        ─── 01 / THESIS
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center gap-2 mb-8">
          <span className="inline-flex items-center gap-2 border border-white/10 bg-white/5 px-3 py-1.5 text-[11px] font-mono-ui uppercase tracking-[0.22em] text-zinc-300">
            <Sparkles className="h-3 w-3 text-violet-400" />
            GTM Advisory · AI Native
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[88px] font-light leading-[0.98] tracking-tighter text-zinc-50 max-w-5xl"
        >
          Profitable growth,
          <br />
          <span className="text-zinc-500">accelerated by </span>
          <span className="relative inline-block">
            <span className="text-violet-400">AI.</span>
            <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-violet-500/0 via-violet-400/70 to-violet-500/0" />
          </span>
        </h1>

        <p className="mt-8 max-w-2xl text-lg md:text-xl text-zinc-400 leading-relaxed">
          Catlyz is the founder-led GTM advisory of{" "}
          <span className="text-zinc-200">Chris Rozic</span> — 19+ years across
          XPON, Datisan and Winja, with advisory board seats guiding GTM at
          Google Cloud and Google Marketing Platform across APAC. Counsel for
          operators who want a senior thinking partner, not another agency.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="#services"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-2 bg-zinc-50 text-zinc-950 px-6 py-3.5 text-sm font-medium hover:bg-white transition-all"
          >
            Explore Services
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="#contact"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-2 border border-white/15 text-zinc-100 px-6 py-3.5 text-sm font-medium hover:border-violet-400/60 hover:bg-violet-500/5 transition-all"
          >
            Schedule a Review
          </a>
        </div>
      </div>
    </section>
  );
};
